import React, { useState } from 'react';
import ReactPhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css';
import './scss/flag-input.scss'
import i18n from '../../i18n';
import { Autocomplete, TextField } from '@mui/material';

export default function FlagInput(props: {
    // 国旗的值
    countryValue?: string;
    // 表单回调
    onChange: (value: string) => void;
    // 国家列表
    countryList: Array<{
        label: string;
        value: string
    }>
    // 是否必填
    required?: boolean;
    // 是否禁用
    disabled?: boolean;
    /** 为 true 时隐藏输入框浮动标签（与 `FormFieldCell` 等外置标签配合） */
    hiddenLabel?: boolean;
}) {
    const { countryValue, countryList, required, hiddenLabel } = props;
    const [currentValue, setCurrentValue] = useState<{ label: string, value: string } | undefined>(
        {
            label: '',
            value: ''
        }
    );

    React.useEffect(() => {
        setCurrentValue(countryList.find(item => item.value === countryValue) || { label: '', value: '' })
    }, [countryList])

    return (
        <div className='flag-input-component'>
            <ReactPhoneInput
                disableDropdown
                value={countryValue || ''}
                inputStyle={{ display: 'none' }}
                buttonClass='flag-input-btn'
            />
            <Autocomplete
                options={countryList}
                size='small'
                autoHighlight
                getOptionLabel={(option) => option.label}
                value={currentValue}
                isOptionEqualToValue={(option) => option.value === countryValue}
                onChange={(event, newValue) => {
                    setCurrentValue(newValue);
                    props.onChange(newValue?.value || '')
                }}
                disableClearable={true}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={hiddenLabel ? ' ' : i18n.t('restaurant_Country_and_Region')}
                        hiddenLabel={Boolean(hiddenLabel)}
                        variant='outlined'
                        value={countryValue || ''}
                        InputLabelProps={{
                            shrink: !hiddenLabel,
                        }}
                        required={required}
                    />
                )}
                disabled={props.disabled}
            />
        </div>

    )

}

